import { AllocationPhaseInput, TimelineVariant } from '@/components/Timeline/allocation/types';
import { LocationTypeCategory } from '@/components/Timeline/Timeline.types';
import { DateTime } from 'luxon';
import { Ref } from 'vue';

type CreateAllocationReturn = {
    createdAllocationId: string;
    updatedVariantsRef: TimelineVariant[];
};

export function useCreateAllocation(
    createAllocation: (
        variantId: string,
        phases: AllocationPhaseInput[],
        locationId: string,
        startDateTime: DateTime,
        endDateTime: DateTime,
        locationTypeCategory: LocationTypeCategory,
    ) => Promise<CreateAllocationReturn | undefined>,
    editableVariant: Ref<TimelineVariant | undefined>,
) {
    async function onCreateAllocation(
        locationId: string,
        startDateTime: DateTime,
        endDateTime: DateTime,
        allocationVariantId: string,
        phases: AllocationPhaseInput[],
        locationTypeCategory: LocationTypeCategory,
        onDone: (isSuccess: boolean) => void,
    ) {
        if (editableVariant.value) {
            try {
                const response = await createAllocation(
                    allocationVariantId,
                    phases,
                    locationId,
                    startDateTime,
                    endDateTime,
                    locationTypeCategory,
                );
                onDone(true);
                return response;
            } catch (error) {
                onDone(false);
            }
        }
        onDone(false);
    }

    return {
        onCreateAllocation,
    };
}
